import { render, staticRenderFns } from "./AddArbitro.vue?vue&type=template&id=4058b3e0&"
import script from "./AddArbitro.vue?vue&type=script&lang=js&"
export * from "./AddArbitro.vue?vue&type=script&lang=js&"
import style0 from "./AddArbitro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports